import React, { useState } from "react";
import Navbarsticky from "./NavbarSticky";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Footer from "./Footer";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    let error = "";
    const emailvalid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobilenumvalid = /^[6-9]\d{9}$/;

    switch (name) {
      case "name":
        if (!value.trim()) error = "Enter your name ";
        break;

      case "email":
        if (!value.trim()) {
          error = "Enter your email";
        } else if (!emailvalid.test(value)) {
          error = "Enter a valid email";
        }
        break;

      case "phone":
        if (!value.trim()) {
          error = "Enter your number";
        } else if (!mobilenumvalid.test(value)) {
          error = "Enter valid 10-digit number";
        }
        break;

      case "city":
        if (!value.trim()) error = "Enter your City";
        break;

      case "message":
        if (!value.trim()) error = "Enter your message";
        break;

      default:
        break;
    }

    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

    setErrors({
      ...errors,
      [name]: validateField(name, value),
    });
  };

  // Submit
  const handleSubmit = (e) => {
    e.preventDefault();

    let newErrors = {};
    Object.keys(formData).forEach((field) => {
      const error = validateField(field, formData[field]);
      if (error) newErrors[field] = error;
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      alert("Enquiry submitted successfully!");

      setFormData({
        name: "",
        email: "",
        phone: "",
        city: "",
        message: "",
      });
      setErrors({});
    }
  };

  return (
    <>
      <Navbarsticky />

      <div className="contact-hero d-flex align-items-center justify-content-center text-center">
        <div className="overlay" />
        <div className="content text-white">
          <h1 className="fw-bold mb-2 my-4">Get in Touch</h1>
          <p>We’d love to help you plan your Andaman journey</p>
        </div>
      </div>

      <Container className="py-5">
        <Row className="g-5">
          <Col lg={5}>
            <div className="info-box p-4 rounded-4 shadow-sm h-100">
              <h4 className="fw-bold mb-4">Contact Information</h4>

              <p>
                <i className="bi bi-telephone-fill text-primary me-2" />
                +91-9933275913
              </p>

              <p>
                <i className="bi bi-envelope-fill text-primary me-2" />
                andamanmakeholidayss@gmail.com
              </p>

              <p>
                <i className="bi bi-geo-alt-fill text-primary me-2" />
                Andaman, India
              </p>

              {/* map */}
              <div className="mt-4">
                <iframe
                  title="Andaman Map"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d1573096.263343645!2d92.7265!3d11.6231!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v0000000000000"
                  width="100%"
                  height="230"
                  style={{ border: 0, filter: "grayscale(100%)" }}
                  loading="lazy"
                  allowFullScreen
                  className="rounded-3"
                />
              </div>
            </div>
          </Col>

          {/* Right Form */}
          <Col lg={7}>
            <div className="contact-form p-4 p-lg-5 rounded-4 shadow-sm">
              <h2 className="fw-bold mb-3">Let’s Connect</h2>

              <Form onSubmit={handleSubmit} noValidate>
                <Row className="g-3">
                  <Col md={6}>
                    <Form.Control
                      name="name"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {errors.name && (
                      <small className="text-danger">{errors.name}</small>
                    )}
                  </Col>

                  <Col md={6}>
                    <Form.Control
                      name="email"
                      type="email"
                      placeholder="Email Address"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                  </Col>

                  <Col md={6}>
                    <Form.Control
                      name="phone"
                      placeholder="Contact Number"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                    {errors.phone && (
                      <small className="text-danger">{errors.phone}</small>
                    )}
                  </Col>

                  <Col md={6}>
                    <Form.Control
                      name="city"
                      placeholder="City"
                      value={formData.city}
                      onChange={handleChange}
                    />
                    {errors.city && (
                      <small className="text-danger">{errors.city}</small>
                    )}
                  </Col>
                </Row>

                <div className="mt-3">
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="message"
                    placeholder="Tell us about your travel plan..."
                    value={formData.message}
                    onChange={handleChange}
                    style={{ height: "9rem" }}
                  />
                  {errors.message && (
                    <small className="text-danger">{errors.message}</small>
                  )}
                </div>

                <Button type="submit" className="take-tour-btn mt-4 px-4 py-2">
                  Submit Enquiry <i className="bi bi-arrow-right ms-2" />
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
}
